const CircleLoaderSvg = () => (
  <svg viewBox="0 0, 100 100" width="40" className="loader">
    <defs>
      <linearGradient id="linear" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(10)">
        <stop offset="10%" className="stop-color" />
        <stop offset="100%" stopColor="whitesmoke" />
      </linearGradient>
    </defs>
    <path
      d="M 50 10 A 40 40 0 1 0 90 50"
      stroke="url(#linear)"
      strokeWidth="13"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export default CircleLoaderSvg;
